<template>
<div>
<navigation></navigation>
<!--Main contents-->
<div class="box_center" id="page_x" v-if="!success">
  <h2 class="shadow">Contact</h2>
  <div id="feedback" v-if="errors.any()">
    <p class="error wrong_name error-box" v-if="errors.has('name')">Please enter your name</p>
    <p class="error wrong_email error-box" v-if="errors.has('email')">Please enter a valid email</p>
    <p class="error wrong_message error-box" v-if="errors.has('message')">Please enter your message</p>
  </div>
  <div class="input">
    <form @submit.prevent="send" name="contact">
      <p class="text_form">
        Name: <br />
        Email: <br />
        Message:
      </p>
      <input type="text" name="name" class="contact_form" v-model="contact.name" v-validate="'required'" data-vv-delay="1000"/>
      <input type="text" name="email" class="contact_form" v-model="contact.from" v-validate="'required|email'" data-vv-delay="1000"/>
      <textarea cols="5" name="message" rows="5" class="text_area" v-model="contact.message" v-validate="'required'" data-vv-delay="1000"></textarea>
      <input type="submit" value="Submit" name="submitButton" title="Submit" class="button submit">
    </form>
  </div>
</div>
<div class="box_center" id="menu_index" v-if="success">
<h2>Success!</h2>
<br>
Your email has been sent. Thank you for contacting us!
</div>
<!--Main contents Ends-->
</div>
</template>

<script>
import Nav from '../components/Nav.vue'
import ContactRepository from '../data/contact.repository'
export default {
  components: {
    navigation: Nav
  },
  data () {
    return {
      success: false,
      contact: {
        from: '',
        name: '',
        message: ''
      }
    }
  },
  methods: {
    send () {
      this.$validator.validateAll().then(() => {
        ContactRepository.send(this.contact).then((result) => {
          this.success = true
        }).catch(() => console.log('An error has occurred'))
      })
    }
  },
  metaInfo: {
    title: 'Contact'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Contact.vue?47a503b8